import {Component, Input, OnInit} from '@angular/core';
import {IHelpVideo} from '@app/models/video-library/help-video.model';
import {PillType} from '@app/shared/components/pill/pill.component';
import {Globals} from '@app/shared/globals/globals';

@Component({
  selector: 'app-video-library-video-card',
  templateUrl: './video-library-video-card.component.html',
  styleUrls: ['./video-library-video-card.component.scss']
})
export class VideoLibraryVideoCardComponent implements OnInit {
  public readonly ePillType = PillType;

  @Input() videoData: IHelpVideo;

  constructor(
    public globals: Globals
  ) {
    this.videoData = undefined!;
  }

  ngOnInit(): void {
  }
}
